import { useState, useEffect } from 'react';

export default function useMessages({ autoHideDelay = 8000, initial = '' } = {}) {
  const [message, setMessage] = useState(initial);
  const [messageType, setMessageType] = useState('');

  function showMessage(msg, type = 'success') {
    setMessage(msg);
    setMessageType(type);
  }

  function showSuccess(msg) {
    showMessage(msg, 'success');
  }

  function showError(msg) {
    showMessage(msg, 'error');
  }

  function showWarning(msg) {
    showMessage(msg, 'warning');
  }

  function showInfo(msg) {
    showMessage(msg, 'info');
  }

  function clearMessage() {
    setMessage(initial);
    setMessageType('');
  }

  useEffect(() => {
    if (message && autoHideDelay > 0) {
      const timer = setTimeout(() => {
        clearMessage();
      }, autoHideDelay);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [message, autoHideDelay]);

  const hasMessage = Boolean(message);

  return {
    message,
    messageType,
    hasMessage,
    showMessage,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    clearMessage,
  };
}
